/* QV-01 (owner 2026-09-24): product quick view from the card eye button.
   Fetches <product url>?section_id=sz-rd-qv (sections/sz-rd-qv.liquid) on demand, shows it as a
   bottom sheet (phone) or popup (desktop). Gallery swipes and plays video; variant pills swap
   price / availability / media; "View & buy" opens the PDP with that variant.
   QUICK-BUY-01 (owner 2026-10-20): a trigger with data-sz-qv-side opens it as a panel from the right,
   and the panel buys: how-many packs (deal sets or bulk steps, from script[data-sz-qb-offer]), a
   - n + counter, Add to bag (one /cart/add.js), then the card's "In your bag" pop-up. The fetch
   starts on pointerdown so the panel is usually filled by the time the finger lifts; until then it
   shows the name and photo the card already has. */
(function () {
  'use strict';
  var cache = {};
  var root, panel, body, lastBtn, gallery = null;

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'sz-qv';
    root.hidden = true;
    root.innerHTML = '<div class="sz-qv__scrim" data-sz-qv-close></div>' +
      '<div class="sz-qv__panel" role="dialog" aria-modal="true" aria-labelledby="sz-qv-title">' +
      '<span class="sz-qv__grab" aria-hidden="true"></span>' +
      '<button type="button" class="sz-qv__close" data-sz-qv-close aria-label="Close quick view">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button>' +
      '<div class="sz-qv__body"></div></div>';
    document.body.appendChild(root);
    panel = root.querySelector('.sz-qv__panel');
    body = root.querySelector('.sz-qv__body');
    root.addEventListener('click', onRootClick);
    swipeToClose();
  }

  function sectionUrl(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=sz-rd-qv';
  }

  function getHtml(url) {
    return cache[url] || (cache[url] = fetch(sectionUrl(url), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('qv ' + r.status);
      return r.text();
    }));
  }
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function open(btn) {
    build();
    lastBtn = btn;
    var url = btn.getAttribute('data-sz-qv');
    var side = btn.hasAttribute('data-sz-qv-side');
    root.classList.toggle('sz-qv--side', side);
    var nm = btn.getAttribute('data-sz-qv-name'), im = btn.getAttribute('data-sz-qv-img');
    body.innerHTML = nm
      ? '<div class="sz-qv__inner sz-qv__shell">' + (im ? '<div class="sz-qv__gallery"><img src="' + esc(im) + '" alt=""></div>' : '') +
        '<div class="sz-qv__info"><h2 class="sz-qv__name" id="sz-qv-title">' + esc(nm) + '</h2><p class="sz-qv__loading">Loading options…</p></div></div>'
      : '<p class="sz-qv__loading">Loading…</p>';
    root.hidden = false;
    document.documentElement.classList.add('sz-qv-lock');
    btn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    root.querySelector('.sz-qv__close').focus({ preventScroll: true });
    getHtml(url).then(function (html) {
      if (lastBtn !== btn || root.hidden) return;
      body.innerHTML = html;
      init();
    }).catch(function () {
      delete cache[url];
      body.innerHTML = '<p class="sz-qv__loading">Couldn’t load the quick view. <a href="' + url + '">Open the product page →</a></p>';
    });
  }

  function close() {
    if (!root || root.hidden) return;
    pauseAll();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sz-qv-lock');
    var done = function () { root.hidden = true; body.innerHTML = ''; gallery = null; qb = null; };
    setTimeout(done, root.classList.contains('sz-qv--side') ? 520 : 260);
    if (lastBtn) { lastBtn.setAttribute('aria-expanded', 'false'); lastBtn.focus({ preventScroll: true }); }
  }

  function loadImg(el) {
    if (!el) return;
    el.querySelectorAll('img[data-src]').forEach(function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
  }

  function init() {
    var track = body.querySelector('[data-sz-qv-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-sz-qv-slide]'));
    var thumbs = Array.prototype.slice.call(body.querySelectorAll('[data-sz-qv-thumb]'));
    thumbs.forEach(loadImg);
    loadImg(slides[0]); loadImg(slides[1]);
    gallery = { track: track, slides: slides, thumbs: thumbs, i: 0 };

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setIndex(i, false);
      }, 60);
    }, { passive: true });

    var pv = body.querySelector('[data-sz-qv-prev]'), nx = body.querySelector('[data-sz-qv-next]');
    if (pv) pv.addEventListener('click', function () { go(gallery.i - 1); });
    if (nx) nx.addEventListener('click', function () { go(gallery.i + 1); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-sz-qv-thumb')); }); });

    body.querySelectorAll('[data-sz-qv-ext]').forEach(function (ext) {
      ext.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = ext.getAttribute('data-sz-qv-ext').replace('autoplay=0', 'autoplay=1');
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.title = 'Product video';
        ext.replaceWith(f);
      });
    });

    body.querySelectorAll('[data-sz-qv-variant]').forEach(function (pill) {
      pill.addEventListener('click', function () { pickVariant(pill); });
    });

    var first = body.querySelector('.sz-qv__pill.is-on[data-media-id]');
    if (first) jumpToMedia(first.getAttribute('data-media-id'), true);
    qbInit();
  }

  function go(i) {
    if (!gallery) return;
    var n = gallery.slides.length;
    i = (i + n) % n;
    gallery.track.scrollTo({ left: i * gallery.track.clientWidth, behavior: 'smooth' });
    setIndex(i, true);
  }

  function setIndex(i, fromNav) {
    if (!gallery || i === gallery.i && !fromNav) return;
    gallery.i = i;
    loadImg(gallery.slides[i]); loadImg(gallery.slides[i + 1]); loadImg(gallery.slides[i - 1]);
    gallery.thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
    var th = gallery.thumbs[i];
    if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    gallery.slides.forEach(function (s, k) {
      if (k === i) return;
      var v = s.querySelector('video'); if (v && !v.paused) v.pause();
      var f = s.querySelector('iframe'); if (f) { var src = f.src; f.src = 'about:blank'; f.src = src.replace('autoplay=1', 'autoplay=0'); }
    });
  }

  function jumpToMedia(id, instant) {
    if (!gallery || !id) return;
    for (var k = 0; k < gallery.slides.length; k++) {
      if (gallery.slides[k].getAttribute('data-media-id') === id) {
        gallery.track.scrollTo({ left: k * gallery.track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
        setIndex(k, true);
        return;
      }
    }
  }

  function pickVariant(pill) {
    body.querySelectorAll('[data-sz-qv-variant]').forEach(function (p) {
      var on = p === pill; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var price = body.querySelector('[data-sz-qv-price]');
    if (price) price.textContent = pill.getAttribute('data-price');
    var st = pill.getAttribute('data-state');
    var av = body.querySelector('[data-sz-qv-avail]');
    if (av) {
      av.setAttribute('data-state', st);
      av.querySelector('.sz-qv__dot').setAttribute('data-state', st);
      av.querySelector('span').textContent = st === 'in' ? 'In stock' : st === 'pre' ? 'Pre-order' : 'Sold out';
    }
    var buy = body.querySelector('[data-sz-qv-buy]');
    if (buy) buy.href = buy.getAttribute('data-base') + '?variant=' + pill.getAttribute('data-sz-qv-variant');
    var cur = body.querySelector('[data-sz-qb-current]');
    if (cur) {
      cur.setAttribute('data-variant', pill.getAttribute('data-sz-qv-variant'));
      cur.setAttribute('data-cents', pill.getAttribute('data-cents') || '0');
      cur.setAttribute('data-max', pill.getAttribute('data-max') || '0');
      cur.setAttribute('data-state', st);
    }
    qbRender(true);
    jumpToMedia(pill.getAttribute('data-media-id'), false);
  }

  /* ---- QUICK-BUY-01: how many + Add to bag ------------------------------------------------- */
  var qb = null;
  function fmt(c) { var d = (Number(c) || 0) / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function inList(list, id) { return !!list && (',' + list + ',').indexOf(',' + id + ',') > -1; }
  function curV() {
    var el = body && body.querySelector('[data-sz-qb-current]');
    if (!el) return null;
    return { id: el.getAttribute('data-variant'), cents: Number(el.getAttribute('data-cents')) || 0, max: Number(el.getAttribute('data-max')) || 0, state: el.getAttribute('data-state') };
  }
  function dealOn(v) { var c = qb.cfg; return c.buy > 0 && c.get > 0 && !c.b2b && (c.all || inList(c.vids, v.id)); }
  function pctOn(v) { var c = qb.cfg; return c.pct > 0 && !c.b2b && (!c.pctVids || inList(c.pctVids, v.id)) ? c.pct : 0; }
  function priced(v, q) {
    var c = qb.cfg, full = v.cents * q, p = pctOn(v), min = c.pctMin || 1;
    if (dealOn(v)) { var free = Math.floor(q / (c.buy + c.get)) * c.get; return { t: v.cents * (q - free), f: full, free: free }; }
    if (p) return { t: q >= min ? Math.round(full * (100 - p) / 100) : full, f: full };
    if (c.b2b) return { t: full, f: full };
    var best = null;
    (c.tiers || []).forEach(function (t) { if (q >= t.q) best = t; });
    if (!best) return { t: full, f: full };
    if (best.t === 'fixed') return { t: Math.max(0, v.cents - best.v * 100) * q, f: full, tier: best };
    return { t: Math.round(full * (100 - best.v) / 100), f: full, tier: best };
  }
  function packList(v) {
    var c = qb.cfg, out = [];
    if (!c.live || c.b2b) return out;
    if (dealOn(v)) { var set = c.buy + c.get; out = [1, c.buy, set, set * 2]; }
    else if (pctOn(v)) out = [1, 5, 10];
    else if ((c.tiers || []).length) out = [1].concat(c.tiers.map(function (t) { return t.q; }));
    else out = [1, 5, 10];
    var cap = v.max > 0 ? v.max : 99, seen = {};
    out = out.filter(function (q) { if (q < 1 || q > cap || seen[q]) return false; seen[q] = 1; return true; });
    return out.length > 1 ? out : [];
  }
  function packNote(v, q) {
    var r = priced(v, q);
    if (r.free) return r.free + ' free';
    if (r.tier) return r.tier.t === 'fixed' ? 'save $' + r.tier.v + ' each' : 'save ' + r.tier.v + '%';
    if (r.f > r.t) return 'save ' + fmt(r.f - r.t);
    return '';
  }
  function qbInit() {
    var box = body.querySelector('[data-sz-qb]'), cfgEl = body.querySelector('[data-sz-qb-offer]');
    if (!box || !cfgEl) { qb = null; return; }
    var cfg = {}; try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}
    qb = { cfg: cfg, n: 1, box: box };
    box.querySelector('[data-sz-qb-dec]').addEventListener('click', function () { qbSet(qb.n - 1); });
    box.querySelector('[data-sz-qb-inc]').addEventListener('click', function () { qbSet(qb.n + 1); });
    box.querySelector('[data-sz-qb-packs]').addEventListener('click', function (e) { var b = e.target.closest('[data-q]'); if (b) qbSet(Number(b.getAttribute('data-q'))); });
    var add = body.querySelector('[data-sz-qb-add]'); if (add) add.addEventListener('click', qbAdd);
    qbRender(true);
    if (lastBtn && lastBtn.getAttribute('data-sz-qv-focus') === 'grade') {
      var pill = body.querySelector('.sz-qv__pill.is-on') || body.querySelector('.sz-qv__pill');
      if (pill) setTimeout(function () { pill.focus({ preventScroll: true }); }, 280);
    }
  }
  function qbSet(n) { if (!qb) return; qb.n = Math.max(1, n); qbRender(false); }
  function qbRender(reset) {
    if (!qb) return;
    var v = curV(); if (!v) return;
    var c = qb.cfg, buyable = v.state === 'in' && !c.plan;
    var add = body.querySelector('[data-sz-qb-add]'), buy = body.querySelector('[data-sz-qv-buy]'), buyTxt = body.querySelector('[data-sz-qb-buytxt]');
    var price = body.querySelector('[data-sz-qv-price]'), was = body.querySelector('[data-sz-qb-was]');
    qb.box.hidden = !buyable;
    if (add) add.hidden = !buyable;
    if (buy) {
      buy.hidden = buyable;
      if (buyTxt) buyTxt.textContent = v.state === 'pre' || c.plan ? 'Pre-order on the product page' : v.state === 'out' ? 'Sold out: see the product page' : 'View & buy';
    }
    if (!buyable) { if (was) was.textContent = ''; if (price) price.textContent = fmt(v.cents); return; }
    if (reset) qb.n = 1;
    var cap = v.max > 0 ? v.max : 99;
    if (qb.n > cap) qb.n = cap;
    var n = qb.n, packs = packList(v);
    var packsEl = qb.box.querySelector('[data-sz-qb-packs]');
    packsEl.hidden = !packs.length;
    var lbl = qb.box.querySelector('.sz-qb__label'); if (lbl) lbl.hidden = !packs.length;
    packsEl.innerHTML = packs.map(function (q) {
      var r = priced(v, q), note = packNote(v, q), on = q === n;
      return '<button type="button" class="sz-qb__pack' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-q="' + q + '">' +
        '<b>' + q + '</b><span>' + fmt(r.t) + '</span>' + (note ? '<i>' + esc(note) + '</i>' : '<i class="is-empty">&nbsp;</i>') + '</button>';
    }).join('');
    qb.box.querySelector('[data-sz-qb-n]').textContent = n;
    qb.box.querySelector('[data-sz-qb-dec]').disabled = n <= 1;
    qb.box.querySelector('[data-sz-qb-inc]').disabled = n >= cap;
    var r = priced(v, n);
    if (price) price.textContent = fmt(r.t);
    if (was) was.textContent = r.f > r.t ? fmt(r.f) : '';
    if (add) { add.disabled = false; add.textContent = 'Add ' + n + ' to bag'; }
    var note = qb.box.querySelector('[data-sz-qb-note]'), say = '';
    if (dealOn(v)) {
      var set = c.buy + c.get, left = set - (n % set);
      say = r.free ? r.free + ' extra free included' + (left < set ? '. Add ' + left + ' more for ' + c.get + ' more' : '') : 'Buy ' + c.buy + ', get ' + c.get + ' extra free';
    } else if (!pctOn(v) && !c.b2b && (c.tiers || []).length) {
      var next = c.tiers.filter(function (t) { return t.q > n; })[0];
      say = next ? 'Add ' + (next.q - n) + ' more to save ' + (next.t === 'fixed' ? '$' + next.v + ' each' : next.v + '%') : (r.tier ? 'Saving ' + (r.tier.t === 'fixed' ? '$' + r.tier.v + ' each' : r.tier.v + '%') : '');
    }
    if (v.max > 0 && n >= v.max) say = 'That’s all ' + v.max + ' we have';
    note.textContent = say;
  }
  function qbAdd() {
    if (!qb) return;
    var v = curV(), add = body.querySelector('[data-sz-qb-add]'), n = qb.n;
    if (!v || !add || add.disabled) return;
    add.disabled = true; add.textContent = 'Adding…';
    var nameEl = body.querySelector('.sz-qv__name'), img = (lastBtn && lastBtn.getAttribute('data-sz-qv-img')) || '';
    if (!img) { var gi = body.querySelector('.sz-qv__slide img'); if (gi) img = gi.getAttribute('src') || gi.getAttribute('data-src') || ''; }
    var r = priced(v, n), name = nameEl ? nameEl.textContent.trim() : 'Item';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v.id), quantity: n }] }) })
      .then(function (res) { if (!res.ok) return res.json().catch(function () { return {}; }).then(function (e) { throw e; }); return res.json(); })
      .then(function () {
        close();
        if (window.szCardToast) window.szCardToast({ id: v.id, name: name, qty: n, img: img, total: r.t, saved: r.f - r.t });
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (cart) {
          if (window.szRdSyncCart) window.szRdSyncCart();
          document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: cart, source: 'qb' } }));
        }).catch(function () {});
      })
      .catch(function (e) {
        if (!qb) return;
        add.disabled = false; add.textContent = 'Add ' + n + ' to bag';
        var note = qb.box.querySelector('[data-sz-qb-note]');
        if (note) note.textContent = (e && e.description) || 'Could not add this. Please try again.';
      });
  }

  function pauseAll() {
    if (!body) return;
    body.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
  }

  function onRootClick(e) {
    if (e.target.closest('[data-sz-qv-close]')) { e.preventDefault(); close(); }
  }

  /* QV-02 (owner 2026-09-24): flick down to close, from anywhere on the sheet (gallery included).
     Direction lock: the first 10px decide — mostly vertical and downward with the sheet scrolled to
     the top = drag the sheet; mostly horizontal = leave it to the gallery swipe. Closes on a pull
     past 25% of the sheet OR a quick flick (> 0.5 px/ms). */
  function swipeToClose() {
    var x0, y0, t0, dy = 0, mode = null;
    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) { mode = 'off'; return; }
      if (root.classList.contains('sz-qv--side')) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); dy = 0;
        mode = e.target.closest('[data-sz-qv-track], .sz-qv__thumbs') ? 'off' : 'sidewait';
        return;
      }
      if (window.innerWidth >= 768) { mode = 'off'; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); dy = 0;
      mode = panel.scrollTop > 2 ? 'off' : null;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (mode === 'off') return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (mode === 'sidewait' || mode === 'side') {
        if (mode === 'sidewait') {
          if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
          if (mx > 0 && Math.abs(mx) > Math.abs(my) * 1.2) { mode = 'side'; panel.style.transition = 'none'; } else { mode = 'off'; return; }
        }
        if (e.cancelable) e.preventDefault();
        dy = Math.max(0, mx);
        panel.style.transform = 'translateX(' + dy + 'px)';
        return;
      }
      if (mode === null) {
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
        mode = (my > 0 && Math.abs(my) > Math.abs(mx) * 1.2) ? 'drag' : 'off';
        if (mode === 'drag') panel.style.transition = 'none';
      }
      if (mode !== 'drag') return;
      if (e.cancelable) e.preventDefault();
      dy = Math.max(0, my);
      panel.style.transform = 'translateY(' + dy + 'px)';
      root.querySelector('.sz-qv__scrim').style.opacity = String(Math.max(.2, 1 - dy / (panel.offsetHeight || 600)));
    }, { passive: false });
    function end() {
      if (mode === 'side') {
        var vs = dy / Math.max(1, Date.now() - t0);
        panel.style.transition = ''; panel.style.transform = '';
        if (dy > 90 || (vs > 0.35 && dy > 40)) close();
        mode = null; return;
      }
      if (mode !== 'drag') { mode = null; return; }
      var v = dy / Math.max(1, Date.now() - t0);
      panel.style.transition = ''; panel.style.transform = '';
      root.querySelector('.sz-qv__scrim').style.opacity = '';
      if (dy > Math.min(120, (panel.offsetHeight || 600) * 0.25) || (v > 0.35 && dy > 40)) close();
      mode = null;
    }
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sz-qv]');
    if (btn) getHtml(btn.getAttribute('data-sz-qv')).catch(function () {});
  }, { passive: true, capture: true });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sz-qv]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    open(btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!root || root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowLeft' && gallery) go(gallery.i - 1);
    if (e.key === 'ArrowRight' && gallery) go(gallery.i + 1);
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('button, a[href], video[controls], iframe');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });
})();
